"use strict";

var _defineProperty = require("/home/circleci/repo/node_modules/gatsby/node_modules/@babel/runtime/helpers/defineProperty");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

exports.__esModule = true;
exports.default = void 0;
var buttonDefaults = {
  large: {
    height: 'xxlarge',
    fontSize: '16px',
    iconSize: '36px'
  },
  small: {
    height: 'xlarge',
    fontSize: '14px',
    iconSize: '28px'
  },
  paddingX: 'base',
  paddingXNoLabel: 'medium',
  paddingY: 'none',
  textTransform: 'inherit',
  textDecoration: 'none',
  fontFamily: 'heading',
  fontWeight: 'bold',
  fontWeightSecondary: 'normal',
  borderRadius: 'xsmall',
  // Primary Button - Defaults
  bgColorPrimary: 'primary',
  bgColorInvPrimary: 'white',
  textColorPrimary: 'white',
  textColorInvPrimary: 'primary',
  iconColorPrimary: 'white',
  iconColorInvPrimary: 'primary',
  hoverIconColorPrimary: 'white',
  hoverIconColorInvPrimary: 'white',
  hoverBorderBottomPrimary: 'white',
  hoverBorderBottomInvPrimary: 'primary',
  hoverBgColorPrimary: 'primary',
  hoverBgColorInvPrimary: 'white',
  hoverTextColorPrimary: 'white',
  hoverTextColorInvPrimary: 'primary',
  borderPrimary: '0',
  borderPrimaryColor: 'none',
  hoverBorderPrimary: '0',
  hoverBorderPrimaryColor: 'none',
  // Secondary Button - Defaults
  bgColorSecondary: 'white',
  bgColorInvSecondary: 'offblack',
  textColorSecondary: 'offblack',
  textColorInvSecondary: 'white',
  borderSecondary: '1.5px solid',
  borderColorSecondary: 'offblack',
  borderColorInvSecondary: 'offblack',
  hoverBorderSecondary: '1.5px solid',
  hoverBorderColorSecondary: 'offblack',
  hoverBorderColorInvSecondary: 'offblack',
  iconColorSecondary: 'offblack',
  iconColorInvSecondary: 'offblack',
  hoverIconColorSecondary: 'offblack',
  hoverIconColorInvSecondary: 'offblack',
  hoverBorderBottomSecondary: 'offblack',
  hoverBorderBottomInvSecondary: 'white',
  hoverBgColorSecondary: 'white',
  hoverTextColorSecondary: 'offblack',
  widthSecondary: 'auto',
  // Link Button - Defaults
  textColorInvLink: 'white',
  textColorLink: 'greydark',
  iconColorLink: 'offblack',
  iconColorInvLink: 'white',
  hoverBorderBottomLink: 'greydark',
  hoverBorderBottomInvLink: 'white',
  textMargin: '2px',
  textMarginIE: '2px',
  linkBorderBottomColor: 'none',
  // Disabled button - Defaults
  hoverTextColorDisabled: 'white',
  textColorDisabled: 'white'
};
var buttons = {
  horizon: _objectSpread({}, buttonDefaults),
  cannesLions: _objectSpread({}, buttonDefaults),
  lionsLive: _objectSpread(_objectSpread({}, buttonDefaults), {}, {
    fontFamily: 'body',
    borderRadius: 'none',
    // Primary Button
    textColorPrimary: 'white',
    textColorInvPrimary: 'black',
    hoverBorderBottomPrimary: 'none',
    hoverBorderBottomInvPrimary: 'black',
    hoverBgColorPrimary: 'secondary',
    hoverTextColorPrimary: 'black',
    hoverIconColorPrimary: 'black',
    // Secondary Button
    textColorSecondary: 'black',
    borderColorSecondary: 'white',
    hoverBorderColorInvSecondary: 'secondary',
    hoverBorderColorSecondary: 'secondary',
    hoverBorderBottomSecondary: 'none',
    hoverBorderInvSecondary: 'secondary',
    hoverBgColorSecondary: 'secondary',
    hoverTextColorSecondary: 'black',
    hoverTextColorInvSecondary: 'black',
    hoverBgColorInvSecondary: 'secondary',
    hoverBorderBottomInvSecondary: 'none',
    textMargin: '5px'
  }),
  money2020: _objectSpread(_objectSpread({}, buttonDefaults), {}, {
    // Secondary Button - Defaults
    bgColorSecondary: 'secondary',
    textColorSecondary: 'white',
    borderColorSecondary: 'secondary',
    iconColorSecondary: 'white',
    hoverBgColorSecondary: 'secondary',
    hoverTextColorSecondary: 'white',
    hoverBorderColorSecondary: 'secondary',
    hoverIconColorSecondary: 'white',
    hoverBorderBottomSecondary: 'white',
    bgColorInvSecondary: 'white',
    textColorInvSecondary: 'secondary',
    borderColorInvSecondary: 'secondary',
    iconColorInvSecondary: 'secondary',
    hoverBgColorInvSecondary: 'white',
    hoverTextColorInvSecondary: 'secondary',
    hoverBorderColorInvSecondary: 'secondary',
    hoverIconColorInvSecondary: 'secondary',
    hoverBorderBottomInvSecondary: 'secondary',
    textTransform: 'uppercase',
    fontWeight: 'bold',
    fontWeightSecondary: 'bold'
  }),
  ascential: _objectSpread(_objectSpread({}, buttonDefaults), {}, {
    borderRadius: 'none',
    // Primary Button
    bgColorPrimary: 'secondary',
    hoverBgColorPrimary: 'primary',
    hoverBorderBottomPrimary: 'none',
    // Link Button
    hoverBorderBottomLink: 'primary'
  }),
  dcl: _objectSpread(_objectSpread({}, buttonDefaults), {}, {
    // Primary Button
    hoverBorderBottomPrimary: 'none',
    hoverBorderBottomInvPrimary: 'primary',
    hoverIconColorPrimary: 'white',
    hoverBgColorPrimary: 'black',
    borderSecondary: 'none',
    hoverBorderSecondary: 'none',
    // Secondary Button
    fontWeightSecondary: 'bold',
    bgColorSecondary: 'accent2',
    textColorSecondary: 'white',
    hoverBorderBottomSecondary: 'none',
    hoverBgColorSecondary: 'black',
    hoverBorderInvSecondary: 'none',
    hoverBgColorInvSecondary: 'accent2',
    iconColorSecondary: 'white',
    hoverIconColorSecondary: 'white',
    hoverTextColorSecondary: 'white',
    hoverBorderBottomInvSecondary: 'none',
    // Link Button
    hoverBorderBottomLink: 'primary',
    textColorLink: 'primary',
    iconColorLink: 'primary',
    // Disabled button
    hoverTextColorDisabled: 'offblack',
    textColorDisabled: 'offblack'
  }),
  lionsCreativity: _objectSpread(_objectSpread({}, buttonDefaults), {}, {
    borderRadius: 'large',
    fontFamily: 'bold',
    paddingX: 'large',
    textMargin: '3px',
    textMarginIE: '10px',
    // Primary Button
    bgColorPrimary: 'primary',
    borderPrimaryColor: 'primary',
    iconColorPrimary: 'white',
    iconColorInvPrimary: 'primary',
    hoverIconColorPrimary: 'primary',
    hoverIconColorInvPrimary: 'primary',
    hoverBgColorPrimary: 'accent2',
    hoverBorderBottomPrimary: 'none',
    hoverBorderBottomInvPrimary: 'accent2',
    hoverTextColorPrimary: 'primary',
    textColorPrimary: 'white',
    // Secondary Button
    bgColorSecondary: 'white',
    bgColorInvSecondary: 'primary',
    borderColorSecondary: 'primary',
    borderColorInvSecondary: 'white',
    hoverBgColorSecondary: 'white',
    hoverBgColorInvSecondary: 'accent2',
    hoverBorderBottomSecondary: 'accent2',
    hoverBorderBottomInvSecondary: 'none',
    hoverBorderColorSecondary: 'primary',
    hoverBorderColorInvSecondary: 'white',
    hoverIconColorSecondary: 'primary',
    hoverTextColorSecondary: 'primary',
    hoverTextColorInvSecondary: 'primary',
    hoverIconColorInvSecondary: 'primary',
    iconColorSecondary: 'primary',
    iconColorInvSecondary: 'white',
    textColorInvSecondary: 'white',
    textColorSecondary: 'primary',
    // Link Button
    linkBorderBottomColor: 'none',
    hoverBorderBottomLink: 'accent2',
    // Disabled button
    hoverTextColorDisabled: 'primary',
    textColorDisabled: 'primary'
  })
};
var _default = buttons;
exports.default = _default;